import { RootState } from '../root.reducers';
import { Xtp, XtpOptions, XtpUiState } from './xtp.types';

export const getXtps = (state: RootState): Xtp[] => state.xtp.entities;

export const getXtpErrors = (state: RootState): { xtp: string, xtpOptions: string, } => state.xtp.errors;

export const getXtpOptions = (state: RootState): XtpOptions[] => state.xtp.xtpOptions;

export const getUiState = (state: RootState): XtpUiState => state.xtp.ui;
